import React, { useEffect } from 'react';
import { XMarkIcon, SparklesIcon, SpeakerWaveIcon, SpeakerXMarkIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import useAssistant from './useAssistant';
import { AssistantConversation, AssistantComposer } from './AssistantChat';

/**
 * Quick-access drawer for the OmniPrac assistant, for pages where it helps to
 * see the result land (e.g. the schedule). The full experience is the
 * Assistant section (pages/Assistant).
 */
const AssistantPanel = ({ onClose, onExecuted }) => {
  const admin = localStorage.getItem('role') === 'admin';
  const assistant = useAssistant({ onExecuted });
  const { status, ready, speak, toggleSpeak } = assistant;

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-brand-deep/30" onMouseDown={onClose}>
      <div className="flex h-full w-full max-w-lg animate-slide-in flex-col bg-slate-50 shadow-2xl" onMouseDown={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-5 py-3.5">
          <span className="grid h-9 w-9 place-items-center rounded-full bg-brand-gradient text-white">
            <SparklesIcon className="h-5 w-5" />
          </span>
          <div className="min-w-0 flex-1">
            <h2 className="text-base font-bold text-brand-deep">OmniPrac Assistant</h2>
            <p className="truncate text-xs text-slate-500">
              {status === null ? 'Checking…' : ready ? `${status.model} · nothing changes until you confirm` : 'Not available'}
            </p>
          </div>
          <Link to="/assistant" title="Open the Assistant section" className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-brand-navy">
            <ArrowTopRightOnSquareIcon className="h-5 w-5" />
          </Link>
          <button onClick={toggleSpeak} title={speak ? 'Stop reading replies aloud' : 'Read replies to voice requests aloud'} className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-brand-navy">
            {speak ? <SpeakerWaveIcon className="h-5 w-5" /> : <SpeakerXMarkIcon className="h-5 w-5" />}
          </button>
          <button onClick={onClose} title="Close (Esc)" className="rounded-md p-1.5 text-slate-400 hover:bg-slate-100">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <AssistantConversation assistant={assistant} admin={admin} className="flex-1" />
        <AssistantComposer assistant={assistant} />
      </div>
    </div>
  );
};

export default AssistantPanel;
